var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCareer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.91 85.0039H0V75.541C0 74.8992 0.520293 74.3789 1.16211 74.3789H22.91V85.0039Z",
    fill: "#CBD2D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42059 74.375V85.0008H0V75.5371C0 74.8953 0.520293 74.375 1.16211 74.375H3.42059Z",
    fill: "#9AA5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1639 84.9998H21.2539V64.9121C21.2539 64.2703 21.7742 63.75 22.416 63.75H44.1639V84.9998Z",
    fill: "#0FB5BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6706 63.75V85H21.25V64.9121C21.25 64.2703 21.7703 63.75 22.4121 63.75H24.6706Z",
    fill: "#099AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.41 84.9998H42.5V54.2871C42.5 53.6453 43.0203 53.125 43.6621 53.125H65.41V84.9998Z",
    fill: "#47A3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9206 53.125V85.0008H42.5V54.2871C42.5 53.6453 43.0203 53.125 43.6621 53.125H45.9206Z",
    fill: "#2186EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3633 26.5623H57.2208C57.8626 26.5623 58.3829 26.042 58.3829 25.4002V10.625H39.3633C38.4351 10.625 37.8814 11.6594 38.3964 12.4317L42.5043 18.5938L38.3964 24.7558C37.8814 25.5279 38.4351 26.5623 39.3633 26.5623Z",
    fill: "#EF4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9244 18.597L40.6124 26.5651H39.3633C38.4351 26.5651 37.8814 25.5306 38.3964 24.7583L42.504 18.597L38.3964 12.4357C37.8816 11.6633 38.4351 10.6289 39.3633 10.6289H40.6124L45.9244 18.597Z",
    fill: "#E12D39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2871 21.2498H73.3787V5.3125H54.2871C53.6453 5.3125 53.125 5.83279 53.125 6.47461V20.0877C53.125 20.7295 53.6453 21.2498 54.2871 21.2498Z",
    fill: "#EF4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5456 5.3125V21.2505H54.2871C53.6453 21.2505 53.125 20.7302 53.125 20.0884V6.47461C53.125 5.83279 53.6453 5.3125 54.2871 5.3125H56.5456Z",
    fill: "#E12D39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0352 44.1734H71.7227V1.16211C71.7227 0.520293 72.2429 0 72.8848 0H75.873C76.5149 0 77.0352 0.520293 77.0352 1.16211V44.1734Z",
    fill: "#46778C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2842 0V44.1738H71.7188V1.16211C71.7188 0.520293 72.239 0 72.8809 0H74.2842Z",
    fill: "#616E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9998 84.9997H63.75V43.6621C63.75 43.0203 64.2703 42.5 64.9121 42.5H83.8377C84.4795 42.5 84.9998 43.0203 84.9998 43.6621V84.9997Z",
    fill: "#F9D264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1706 42.5V85H63.75V43.6621C63.75 43.0203 64.2703 42.5 64.9121 42.5H67.1706Z",
    fill: "#EFC356"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/career.b3f0ce82cf34db87055af611eb1e56a7.svg";
export { ForwardRef as ReactComponent };